import React from 'react';
import './SkeletonLoader.css';

export default function SkeletonLoader() {
  return (
    <div className="skeleton-loader">
      <div className="skeleton-loader__header">
        <div className="skeleton skeleton--counter"></div>
        <div className="skeleton skeleton--search"></div>
        <div className="skeleton skeleton--button"></div>
      </div>

      <div className="skeleton-loader__controls">
        <div className="skeleton skeleton--text"></div>
        <div className="skeleton skeleton--buttons"></div>
      </div>

      <div className="skeleton-loader__grid">
        {[...Array(12)].map((_, index) => (
          <div key={index} className="skeleton skeleton--card"></div>
        ))}
      </div>
    </div>
  );
}
